import { useState } from 'react';
import { ApiError } from '../../services/api';

interface ErrorDisplayProps {
  error: string | Error | null;
}

export function ErrorDisplay({ error }: ErrorDisplayProps) {
  const [copied, setCopied] = useState(false);
  const [expanded, setExpanded] = useState(false);

  if (!error) return null;

  const isApiError = error instanceof ApiError;
  const message = error instanceof Error ? error.message : error;
  const details = isApiError ? (error as ApiError).details : null;

  const handleCopy = async () => {
    const textToCopy = details || message;
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="rounded-md bg-red-50 border border-red-200 p-3">
      <div className="flex items-start justify-between gap-2">
        <p className="text-sm text-red-800 flex-1">{message}</p>
        <button
          type="button"
          onClick={handleCopy}
          className="flex-shrink-0 px-2 py-1 text-xs font-medium text-red-700 bg-red-100 hover:bg-red-200 rounded border border-red-300 transition-colors"
          title="Copy error details"
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>

      {details && (
        <div className="mt-2">
          <button
            type="button"
            onClick={() => setExpanded(!expanded)}
            className="text-xs text-red-600 hover:text-red-800 underline"
          >
            {expanded ? 'Hide details' : 'Show details'}
          </button>

          {expanded && (
            <pre className="mt-2 p-2 bg-red-100 rounded text-xs text-red-900 overflow-x-auto whitespace-pre-wrap font-mono">
              {details}
            </pre>
          )}
        </div>
      )}
    </div>
  );
}
